import { useHistory } from "react-router-dom";
import { CardText, Eject, GeoAlt, PhoneVibrate, TelephoneOutbound, ArrowRightSquare, StopCircle, CheckLg, CircleFill } from 'react-bootstrap-icons';
import { setRejectServicePopup, setReferServicePopup, stopService, resumeService } from "../../store/api/Services";
import { useDispatch } from "react-redux";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStopCircle } from "@fortawesome/free-solid-svg-icons";
import { setErrorDialog } from "../../../store/api/CommonFunctions";
import { Form, FormGroup } from "react-bootstrap";
import { useLayoutEffect, useRef, useState } from "react";
function TaskItem(props) {
    const { item, Rejectable, Referrable, stopDescList } = props;
    const [currStopDesc, setCurrStopDesc] = useState(item.StopDesc);
    const [stopDone, setStopDone] = useState(item.StoppedInStatus);
    const [pending, setPending] = useState(false);
    const [showBtnTitles, setShowBtnTitles] = useState(true);
    const bodyRef = useRef();
    const history = useHistory();
    const dispatch = useDispatch();
    const popStopService = (
        <Popover id="popStopService" style={{ fontFamily: "Vazir", minWidth: "350px" }} onClick={e => e.stopPropagation()}>
            <Popover.Title className="headerStyle"><FontAwesomeIcon icon={faStopCircle} size="lg" /> توقف سرویس</Popover.Title>
            <Popover.Content className="bodyStyle" style={{ paddingTop: "2px" }}>
                {stopDescList?.Data &&
                    <FormGroup>
                        <select className="tableRowInput" onChange={e => setCurrStopDesc(e.target.value)}>
                            <option value="">انتخاب کنید</option>
                            {stopDescList.Data.map((desc, i) => <option key={i} value={desc.InfoName}>{desc.InfoName}</option>)}
                        </select>
                        <Form.Control value={currStopDesc ?? ""} onChange={e => setCurrStopDesc(e.target.value)} />
                        <Button className="group-Btn mt-1" variant="info" onClick={stop} disabled={item?.IsArchive || item?.SendDeliveryDate}><CheckLg size={18} />&nbsp;ثبت اطلاعات</Button>
                    </FormGroup>
                }
            </Popover.Content>
        </Popover>
    )
    function stop() {
        if ((currStopDesc ?? "") === "") {
            return;
        }
        setPending(true);
        const onStopDone = (res) => {
            setPending(!(res.Data || res.Error));
            if (res.Data) {
                item.StoppedInStatus = true;
                item.StopDesc = currStopDesc;
                setStopDone(true);
                setErrorDialog(dispatch, "success", "توقف سرویس");
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "توقف سرویس");
            }
        }
        stopService(item.ServiceType, item.ServiceID, currStopDesc, onStopDone);
    }
    function resume() {
        setPending(true);
        const onResumeDone = (res) => {
            setPending(!(res.Data || res.Error));
            if (res.Data) {
                item.StoppedInStatus = false;
                setStopDone(false);
                setErrorDialog(dispatch, "success", "ادامه کار سرویس");
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ادامه کار سرویس");
            }
        }
        resumeService(item.ServiceType, item.ServiceID, onResumeDone);
    }
    const showRejectPop = () => {
        dispatch(setRejectServicePopup({ show: true, serviceID: item.ServiceID, serviceType: item.ServiceType }));
    }
    const showReferPop = () => {
        dispatch(setReferServicePopup({ show: true, serviceID: item.ServiceID, serviceType: item.ServiceType }));
    }
    const showService = () => {
        history.push(`/Services/Service/${item.ServiceID}/${item.ServiceType}`, null);
    }
    useLayoutEffect(() => {
        setShowBtnTitles(bodyRef.current.clientWidth > 429);
    }, [item])
    return (
        <div className="col-md-4">
            <div className="card mt-2" style={{ backgroundColor: "rgb(206 206 207)", textAlign: "justify", boxShadow: '0px 0px 4px #070d35' }}>
                <div className="card card-header" style={{ boxShadow: '0px 0px 4px #070d35', fontWeight: "bold", fontSize: "13px" }}><span><span style={{ backgroundColor: item.BackgroundColor, marginLeft: "5px", borderRadius: "2px", width: "20px", display: "inline-block" }}>&nbsp;</span><span>سرویس {item.ServiceType.replace("install", "نصب").replace("repair", "تعمیر")} شماره {item.InvoiceNumber}</span></span></div>
                <div className="card-body row scThin" style={{ color: 'black', maxHeight:"226px", overflowY:"auto" }} ref={bodyRef}>
                    <div className="col-5 mt-2" > نام محصول </div><div className="col-7 mt-2"> {item.ProductName} </div>
                    <div className="col-5 mt-2"> مدل محصول </div><div className="col-7 mt-2"> {item.ProductModel} </div>
                    <div className="col-5 mt-2"> شماره سریال</div><div className="col-7 mt-2"> {item.SerialNumber} </div>
                    <div className="col-5 mt-2"> نام مشتری</div><div className="col-7 mt-2"> {item.CustomerName} </div>
                    <div className="col-5 mt-2"> موبایل مشتری</div><div className="col-7 mt-2"> {item.CustomerMobile} {item.CustomerMobile.length > 8 && <a style={{ color: "red" }} href={'tel:' + item.CustomerMobile}><PhoneVibrate size={21} /></a>}</div>
                    <div className="col-5 mt-2"> تلفن مشتری</div><div className="col-7 mt-2"> {item.CustomerPhone}{item.CustomerPhone.length > 8 && <a style={{ color: "red" }} href={'tel:' + item.CustomerPhone}> <TelephoneOutbound size={18} /></a>}</div>
                    <div className="col-5 mt-2"> آدرس مشتری</div><div className="col-7 mt-2" ><span> {item.ServiceAddress}</span> </div>
                </div>
                <div className="row" style={{ padding: "5px", paddingRight: "10px" }}>
                    <div >
                        <Button variant="success" className={"group-Btn"+(showBtnTitles?"":" tooltipBtn")} onClick={showService} data-tooltip="نمایش"><CardText size={20} />{showBtnTitles && ' نمایش '}</Button>
                        {Rejectable && <Button variant="danger" className={"group-Btn"+(showBtnTitles?"":" tooltipBtn")} onClick={showRejectPop} data-tooltip="رد سرویس"><Eject size={20} />{showBtnTitles && ' رد '}</Button>}
                        <Button className={"group-Btn"+(showBtnTitles?"":" tooltipBtn")} data-tooltip="مسیر"><GeoAlt size={20} /><a style={{ color: "White" }} href={'https://maps.google.com/?q=' + item.Latitude + ',' + item.Longitude} target="_blank">{showBtnTitles && ' مسیر '}</a></Button>
                        {Referrable && <Button className={"group-Btn"+(showBtnTitles?"":" tooltipBtn")} style={{ backgroundColor: "#bd4906", borderColor: "#bd4906" }} onClick={showReferPop} data-tooltip="ارجاع"><ArrowRightSquare size={20} />{showBtnTitles && ' ارجاع '}</Button>}

                        {!stopDone ?
                            <OverlayTrigger placement="top" trigger="click" overlay={popStopService} rootClose>
                                <Button className={"group-Btn"+(showBtnTitles?"":" tooltipBtn")} variant="secondary" keyname="stop" disabled={pending} data-tooltip="توقف سرویس"><StopCircle size={20} />{showBtnTitles && ' توقف سرویس'}</Button>
                            </OverlayTrigger> :
                            <Button className={"group-Btn"+(showBtnTitles?"":" tooltipBtn")} variant="secondary" onClick={resume} keyname="resume" disabled={pending} data-tooltip="ادامه کار"><CircleFill size={20} />{showBtnTitles && ' ادامه کار'}</Button>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TaskItem;